import { useEffect, useState } from "react";
import axios from "axios";
import { POSTS } from "@/lib/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SV_MONTHS = ["januari", "februari", "mars", "april", "maj", "juni", "juli",
    "augusti", "september", "oktober", "november", "december"];

function parseSvDate(str) {
    const m = /^(\d{1,2})\s+([a-zåäö]+)\s+(\d{4})$/i.exec((str || "").trim());
    if (!m) return 0;
    const month = SV_MONTHS.indexOf(m[2].toLowerCase());
    return month < 0 ? 0 : Date.UTC(Number(m[3]), month, Number(m[1]));
}

const STATIC_POSTS = POSTS.map((p) => ({ ...p, source: "static", sortKey: parseSvDate(p.date) }));

export function usePosts(limit) {
    const [posts, setPosts] = useState(STATIC_POSTS);

    useEffect(() => {
        let alive = true;
        axios
            .get(`${API}/blog/posts`)
            .then(({ data }) => {
                if (!alive) return;
                const dynamic = (data.items || []).map((p) => ({
                    ...p,
                    sortKey: Date.parse(p.published_at) || 0,
                }));
                const slugs = new Set(dynamic.map((p) => p.slug));
                const merged = [...dynamic, ...STATIC_POSTS.filter((p) => !slugs.has(p.slug))]
                    .sort((a, b) => b.sortKey - a.sortKey);
                setPosts(merged);
            })
            .catch(() => {});
        return () => { alive = false; };
    }, []);

    return limit ? posts.slice(0, limit) : posts;
}

export async function fetchDynamicPost(slug) {
    const { data } = await axios.get(`${API}/blog/posts/${encodeURIComponent(slug)}`);
    return data;
}
